import { convertDate, convertToCurrency, convertNumberBR } from 'xpi-black-ui/Utils/helpers';
import { hasAssetBuy, removeMaskPercentage } from 'utils/helpers';
import { normalizeFilters } from './filters';

import { valueInPercentage, showAssetDescription } from './product';

import { getAssetImage, saveImagesInLocalStorage } from '../../utils/assetImage';


export const normalizeMenus = menus => (
  menus.map(menu => ({
    ...menu,
    referenciaParametro: menu.referenciaMenu,
    referenciaMenu: `/operacoes/${menu.referenciaMenu}`,
    tiposOperacao: menu.tiposOperacao.map(tipoOperacao => ({
      ...tipoOperacao,
      link: `/operacoes/${menu.referenciaMenu}/${tipoOperacao.id}`,
      title: `${tipoOperacao.descricao} (0)`,
    })),
  }))
);

const createOperationsContract = async (operations) => {
  const promises = await Promise.all(operations.map(async (operation) => {
    const isAssetIDI = operation.ativo.nome === 'IDI';
    const { precoReferencia, multiplicador } = operation;

    const precoOperacao = multiplicador > 1
      ? operation?.precoOperacao * multiplicador
      : operation?.precoOperacao;

    return {
      ...operation,
      isHighlight: operation.isHighlight,
      ativoNome: operation.ativo.nome,
      estruturaNome: operation.estrutura.nome,
      mensagemCompraAtivo: hasAssetBuy(operation.papelIncluso),
      descricaoAtivo: showAssetDescription(operation.tipoAtivo) ? operation.descricaoAtivo : null,
      prejuizoMaximoFomatado: operation.prejuizoMaximo === -1
        ? 'Ilimitado'
        : convertToCurrency(operation?.prejuizoMaximo),
      lucroMaximoFomatado: operation.lucroMaximo === -1
        ? 'Ilimitado'
        : convertToCurrency(operation?.lucroMaximo),
      dataEncerramentoFormatado: convertDate(operation?.vencimento),
      comissaoFormatado: isAssetIDI ? `R$ ${convertNumberBR(operation?.comissao)}` : `${convertNumberBR(operation?.pctComissao, 2)} %`,
      comissaoPercentual: removeMaskPercentage(`${operation?.pctComissao}%`),
      precoOperacaoFormatado: isAssetIDI ? `R$ ${convertNumberBR(operation?.precoOperacao)}` : valueInPercentage({ value: precoOperacao, multiplier: multiplicador, reference: precoReferencia }),
      imagem: await getAssetImage(operation?.ativo.nome),
    };
  }));

  return promises;
};

export const normalizeOperations = async (operations) => {
  let assets = operations?.map(operation => operation.ativo);
  assets = assets.reduce((unique, item) => (
    unique.filter(items => items.nome === item.nome).length > 0 ? unique : [...unique, item]
  ), []);

  await saveImagesInLocalStorage(assets);
  const normalizedOperations = await createOperationsContract(operations);

  return normalizedOperations
    .sort((a, b) => (
      b.asset > a.asset ? -1 : 1
    ))
    .sort((a, b) => (
      a.asset === b.asset && a.name < b.name ? -1 : 1
    ));
};

export const filtersTypes = [
  { name: 'categoria', title: 'Categorias de ativos' },
  { name: 'ativo', title: 'Ativos' },
  { name: 'tipoEstrategia', title: 'Categorias de estruturas' },
  { name: 'estrutura', title: 'Estruturas' },
  { name: 'encerramento', title: 'Encerramentos' },
  { name: 'papelIncluso', title: 'Compra da ação' },
];

const uniqueItem = arr => (
  arr
    .reduce((unique, item) => (
      unique.filter(items => items.nome === item.nome).length > 0 ? unique : [...unique, item]
    ), [])
    .filter(item => item.nome !== null)
);

export const normalizeOperationsFilters = (operations) => {
  const filterAssets = operations.map(operation => ({ nome: operation.ativo.nome }));
  const filterCategory = operations.map(operation => ({ nome: operation.categoriaAtivo }));
  const filterStructures = operations.map(operation => ({ nome: operation.estruturaNome }));
  const filterTypeStrategie = operations.map(operation => ({ nome: operation.tipoEstrategia }));
  const filterClosingDate = operations.map(operation => ({ nome: operation.dataEncerramentoFormatado }));

  // Filtro com compra ou não da ação
  const filterWithAsset = [];
  const buyAsset = operations?.find(operation => operation?.papelIncluso);
  const notBuyAsset = operations?.find(operation => !operation?.papelIncluso);

  if (buyAsset) {
    filterWithAsset.push({ nome: 'Com a compra da ação' });
  }

  if (notBuyAsset) {
    filterWithAsset.push({ nome: 'Sem a compra da ação' });
  }

  const filters = {
    papelIncluso: filterWithAsset,
    ativo: uniqueItem(filterAssets),
    categoria: uniqueItem(filterCategory),
    estrutura: uniqueItem(filterStructures),
    encerramento: uniqueItem(filterClosingDate),
    tipoEstrategia: uniqueItem(filterTypeStrategie),
  };

  return normalizeFilters(filters, filtersTypes);
};
